import React from 'react';
import { inject, observer } from 'mobx-react';

import IntroStep4 from './portalintro/IntroStep4';

@inject('portalThemeStore')
@observer
class E9ToolBarMore extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const { portalThemeStore } = this.props;
    portalThemeStore.getToolbarMoreMenu();
  }

  render() {
    return (
      <div className="e9header-toolbar-more">
        <IntroStep4 ecId={`${(this && this.props && this.props.ecId) || ''}_IntroStep4@km90hx`} />
      </div>
    );
  }
}

export default E9ToolBarMore;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/E9ToolBarMore.js